/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../quiz-api";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const createQuiz = /* GraphQL */ `mutation CreateQuiz(
  $input: CreateQuizInput!
  $condition: ModelQuizConditionInput
) {
  createQuiz(input: $input, condition: $condition) {
    id
    ownerIdAndWsId
    creator
    name
    requiredPassPercentage
    version
    description
    createdAt
    latestEditor
    updatedAt
    publication_state
    relatedPages
    questionsCount
    questionsOrder
    stats
    meta
    __typename
  }
}
` as GeneratedMutation<
    APITypes.CreateQuizMutationVariables,
    APITypes.CreateQuizMutation
>;
export const updateQuiz = /* GraphQL */ `mutation UpdateQuiz(
  $input: UpdateQuizInput!
  $condition: ModelQuizConditionInput
) {
  updateQuiz(input: $input, condition: $condition) {
    id
    ownerIdAndWsId
    creator
    name
    requiredPassPercentage
    version
    description
    createdAt
    latestEditor
    updatedAt
    publication_state
    relatedPages
    questionsCount
    questionsOrder
    stats
    __typename
  }
}
` as GeneratedMutation<
    APITypes.UpdateQuizMutationVariables,
    APITypes.UpdateQuizMutation
>;
export const deleteQuiz = /* GraphQL */ `mutation DeleteQuiz(
  $input: DeleteQuizInput!
  $condition: ModelQuizConditionInput
) {
  deleteQuiz(input: $input, condition: $condition) {
    id
    ownerIdAndWsId
    creator
    name
    requiredPassPercentage
    version
    description
    createdAt
    latestEditor
    updatedAt
    publication_state
    relatedPages
    questionsCount
    questionsOrder
    stats
    __typename
  }
}
` as GeneratedMutation<
    APITypes.DeleteQuizMutationVariables,
    APITypes.DeleteQuizMutation
>;
export const createQuizQuestion = /* GraphQL */ `mutation CreateQuizQuestion(
  $input: CreateQuizQuestionInput!
  $condition: ModelQuizQuestionConditionInput
) {
  createQuizQuestion(input: $input, condition: $condition) {
    id
    ownerIdAndWsId
    quizId
    text
    options
    __typename
  }
}
` as GeneratedMutation<
    APITypes.CreateQuizQuestionMutationVariables,
    APITypes.CreateQuizQuestionMutation
>;
export const updateQuizQuestion = /* GraphQL */ `mutation UpdateQuizQuestion(
  $input: UpdateQuizQuestionInput!
  $condition: ModelQuizQuestionConditionInput
) {
  updateQuizQuestion(input: $input, condition: $condition) {
    id
    ownerIdAndWsId
    quizId
    text
    options
    __typename
  }
}
` as GeneratedMutation<
    APITypes.UpdateQuizQuestionMutationVariables,
    APITypes.UpdateQuizQuestionMutation
>;
export const deleteQuizQuestion = /* GraphQL */ `mutation DeleteQuizQuestion(
  $input: DeleteQuizQuestionInput!
  $condition: ModelQuizQuestionConditionInput
) {
  deleteQuizQuestion(input: $input, condition: $condition) {
    id
    ownerIdAndWsId
    quizId
    text
    options
    __typename
  }
}
` as GeneratedMutation<
    APITypes.DeleteQuizQuestionMutationVariables,
    APITypes.DeleteQuizQuestionMutation
>;
export const createQuizAnswer = /* GraphQL */ `mutation CreateQuizAnswer(
  $input: CreateQuizAnswerInput!
  $condition: ModelQuizAnswerConditionInput
) {
  createQuizAnswer(input: $input, condition: $condition) {
    id
    ownerIdAndWsId
    quizAndUserId
    quizId
    userId
    attempt
    completedAt
    duration
    answers
    score
    status
    __typename
  }
}
` as GeneratedMutation<
    APITypes.CreateQuizAnswerMutationVariables,
    APITypes.CreateQuizAnswerMutation
>;
export const updateQuizAnswer = /* GraphQL */ `mutation UpdateQuizAnswer(
  $input: UpdateQuizAnswerInput!
  $condition: ModelQuizAnswerConditionInput
) {
  updateQuizAnswer(input: $input, condition: $condition) {
    id
    ownerIdAndWsId
    quizAndUserId
    quizId
    userId
    attempt
    completedAt
    duration
    answers
    score
    status
    __typename
  }
}
` as GeneratedMutation<
    APITypes.UpdateQuizAnswerMutationVariables,
    APITypes.UpdateQuizAnswerMutation
>;
export const deleteQuizAnswer = /* GraphQL */ `mutation DeleteQuizAnswer(
  $input: DeleteQuizAnswerInput!
  $condition: ModelQuizAnswerConditionInput
) {
  deleteQuizAnswer(input: $input, condition: $condition) {
    id
    ownerIdAndWsId
    quizAndUserId
    quizId
    userId
    attempt
    completedAt
    duration
    answers
    score
    status
    __typename
  }
}
` as GeneratedMutation<
    APITypes.DeleteQuizAnswerMutationVariables,
    APITypes.DeleteQuizAnswerMutation
>;
export const createQuizStats = /* GraphQL */ `mutation CreateQuizStats(
  $input: CreateQuizStatsInput!
  $condition: ModelQuizStatsConditionInput
) {
  createQuizStats(input: $input, condition: $condition) {
    id
    ownerIdAndWsId
    quizAndUserId
    quizId
    userId
    answerId
    completedAt
    attempt
    score
    status
    userIdAndStatus
    completePercentage
    __typename
  }
}
` as GeneratedMutation<
    APITypes.CreateQuizStatsMutationVariables,
    APITypes.CreateQuizStatsMutation
>;
export const updateQuizStats = /* GraphQL */ `mutation UpdateQuizStats(
  $input: UpdateQuizStatsInput!
  $condition: ModelQuizStatsConditionInput
) {
  updateQuizStats(input: $input, condition: $condition) {
    id
    ownerIdAndWsId
    quizAndUserId
    quizId
    userId
    answerId
    completedAt
    attempt
    score
    status
    userIdAndStatus
    completePercentage
    __typename
  }
}
` as GeneratedMutation<
    APITypes.UpdateQuizStatsMutationVariables,
    APITypes.UpdateQuizStatsMutation
>;
export const deleteQuizStats = /* GraphQL */ `mutation DeleteQuizStats(
  $input: DeleteQuizStatsInput!
  $condition: ModelQuizStatsConditionInput
) {
  deleteQuizStats(input: $input, condition: $condition) {
    id
    ownerIdAndWsId
    quizAndUserId
    quizId
    userId
    answerId
    completedAt
    attempt
    score
    status
    userIdAndStatus
    completePercentage
    __typename
  }
}
` as GeneratedMutation<
    APITypes.DeleteQuizStatsMutationVariables,
    APITypes.DeleteQuizStatsMutation
>;
